import { TokenService } from '@/services/storage.service'

export const state = {
  accessToken: TokenService.getToken() || null, // The JWT
  refreshToken: TokenService.getRefreshToken() || null,
  expiryTokenDate: TokenService.getExpireTokenDate() || null,
  tokenType: TokenService.getTokenType() || null,
  payload: null,
  isAuthenticatePending: false,
  errorOnAuthenticate: null,
  user: null,
  currentRole: null,
  resourcesPermissions: []
}
